var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{staticClass:"modalAlert",attrs:{"hide-header":"","hide-footer":"","centered":"","no-close-on-esc":"","no-close-on-backdrop":"","size":"sm","id":_vm.idModal}},[_c('div',{style:({
        color: _vm.colorFont,
      }),attrs:{"id":"mensagem"}},[_vm._v(" "+_vm._s(_vm.msg)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }